import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  fetchWebsiteSettings,
  filtersInitialState,
  setSelectedFilterValue,
  sortsInitialState,
  updateWebsiteSettings,
} from 'store/settings/settingsSlice';

export const updateDefaultLandingInSettings = createAsyncThunk(
  'comparisonReducer/updateDefaultLandingInSettings',
  async (_, thunkAPI) => {
    const { filters, sortBy } = thunkAPI.getState().settingsReducer;
    try {
      if (filters === filtersInitialState && sortBy === sortsInitialState) {
        await thunkAPI.dispatch(
          fetchWebsiteSettings({ shouldApplyToOtherReducers: false })
        );
      }
      thunkAPI.dispatch(
        setSelectedFilterValue({
          value: 'content',
          componentName: 'defaultLandingPageSelectBox',
          parentPlatform: 'public',
        })
      );
      await thunkAPI
        .dispatch(updateWebsiteSettings({ shouldApplyToOtherReducers: false }))
        .unwrap();
      return { isSuccessful: true };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  updateDefaultLandingPage: {
    successful: false,
    error: null,
  },
};

export const comparisonSlice = createSlice({
  name: 'comparisonSlice',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(updateDefaultLandingInSettings.fulfilled, (state) => {
      state.updateDefaultLandingPage.successful = true;
    });
  },
});
